import { Link, useParams } from 'react-router-dom'
import { OnAirBadge } from '../../components/LivePlayer'
import { PublicLayout } from '../../components/PublicLayout'
import { CopyButton, EmptyState, LoadingBlock } from '../../components/ui'
import { usePublicLive, usePublicShow } from '../../hooks/usePublic'
import { formatDate, formatDuration } from '../../utils/format'

export function PublicShowPage() {
  const { workspaceSlug = '', showSlug = '' } = useParams()
  const show = usePublicShow(workspaceSlug, showSlug)
  const live = usePublicLive(workspaceSlug, showSlug)
  if (show.isPending) {
    return (
      <PublicLayout>
        <LoadingBlock />
      </PublicLayout>
    )
  }
  if (show.isError) {
    return (
      <PublicLayout title="Not found">
        <EmptyState title="There is nothing here" body="This show has no published episodes, or the address is wrong." />
      </PublicLayout>
    )
  }
  const data = show.data
  return (
    <PublicLayout title={data.title}>
      <header className={`public-show${data.artwork_url ? ' has-art' : ''}`}>
        {data.artwork_url && <img className="artwork" src={data.artwork_url} alt="" />}
        <div className="stack-sm">
          <h1>{data.title}</h1>
          {data.author && <p className="muted">{data.author}</p>}
          {data.description && <p className="prewrap">{data.description}</p>}
          <div className="row">
            <a className="btn btn-secondary" href={data.feed_url}>
              RSS feed
            </a>
            <CopyButton text={data.feed_url} label="Copy the feed address" />
          </div>
        </div>
      </header>
      {live.data?.on_air && (
        <Link to={`/p/${workspaceSlug}/${showSlug}/live`} className="live-banner">
          <OnAirBadge />
          <strong>{live.data.title}</strong>
          <span className="muted">Watch live →</span>
        </Link>
      )}
      <ol className="public-episodes">
        {data.episodes.map((episode) => (
          <li key={episode.slug}>
            <Link to={`/p/${workspaceSlug}/${showSlug}/${episode.slug}`} className="public-episode">
              {episode.image_url && <img src={episode.image_url} alt="" />}
              <div className="stack-sm">
                <strong>{episode.title}</strong>
                <span className="muted small">
                  {formatDate(episode.published_at)}
                  {episode.duration_ms != null && ` · ${formatDuration(episode.duration_ms)}`}
                </span>
                {episode.summary && <p className="muted clamp-2">{episode.summary}</p>}
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </PublicLayout>
  )
}
